import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { ObjectType } from 'src/app/data/constants/object-type.enum';
import { ButtonVariant, IOptionProps } from '@amobee/component-library';
import { LanguageConst } from 'src/app/data/constants/language.const';
import { IFooterProp } from 'src/app/common/components/footer/footer.component';
import { MessageService } from 'src/app/services/message.service';
import { SampleVideoOptions, VideoOptions } from 'src/app/data/constants/creative-produce.const';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { CampaignAdapter } from 'src/adapters/campaign-adapter';

@Component({
    selector: 'creative-edit',
    templateUrl: './creative-edit.component.html',
    styleUrls: ['./creative-edit.component.scss']
})

export class CreativeEditComponent implements OnInit {

    ngOnInit() {
        this.backToCampaignId = this.route.snapshot.queryParamMap.get('campaignId');
        this.messageService.sendFormTitle(['Produce a Video with Mediacorp', false]);
        this.isVideoProduce = this.route.snapshot.queryParamMap.get('isVideoProduce') === "true";
        this.planId = this.route.snapshot.queryParamMap.get('planId');
        _.forEach(LanguageConst, (value: any) => {
            this.languages.push(value);
        });

        this.campaignAdapter.isMultiAdvertiser().then(((isMultiAdvertiser: boolean) => {
            if (isMultiAdvertiser) {
                if (this.planId) {
                    this.campaignAdapter.getPlan(parseInt(this.planId)).then((resp) => {
                        this.breadcrumbService.prepareBreadcrumb(resp.customer_id, resp.advertiser_id, resp.brand_id);
                        this.campaignAdapter.updateCBAId(resp.customer_id, resp.advertiser_id, resp.brand_id);
                    });
                } else {
                    this.campaignAdapter.getCBAId().then((resp) => {
                        this.breadcrumbService.prepareBreadcrumb(resp.customerId, resp.advertiserId, resp.brandId);
                        this.campaignAdapter.updateCBAId(resp.customerId, resp.advertiserId, resp.brandId);
                    });
                }
            }
        }));
    }

    constructor(private modal: ModalService,
        private router: Router,
        private route: ActivatedRoute,
        private messageService: MessageService,
        private campaignAdapter: CampaignAdapter,
        private breadcrumbService: BreadcrumbService) { }

    languages: Array<any> = [];
    selectedLanguage: Array<string> = [];
    selectedVideoOptions: Array<any> = [];
    isVideoProduce: boolean;
    isCreativeRename: boolean = false;
    quantityOptions: Array<number> = _.range(1, 10);
    showMoreInformation: boolean = false;
    previewUrl: string = '';
    planId: string;
    backToCampaignId: string;
    backingToCampaignPage: boolean = false;
    @ViewChild('videoControls', { static: false }) public videoControls: ElementRef;
    footerButtons: Array<IFooterProp> = [
        {
            variant: ButtonVariant.NEUTRAL,
            label: 'Cancel',
            onClick: () => {
                this.cancel();
            },
            showIcon: () => this.backingToCampaignPage ? "Process" : null,
            iconPosition: "right",
            isDisabled: () => this.backingToCampaignPage
        },
        {
            variant: ButtonVariant.PRIMARY,
            label: 'Name Creatives',
            onClick: () => {
                this.toCreativeNamePage();
            }
        }
    ];

    videoOptions: Array<any> = VideoOptions;
    sampleVideoOptions: Array<any> = Object.values(SampleVideoOptions);

    onLanguageChange($event, languageLabel) {
        if ($event && $event.target && $event.target.checked) {
            this.selectedLanguage.push(languageLabel);
        } else {
            this.selectedLanguage = this.selectedLanguage.filter(language => language !== languageLabel);
        }
    }

    onVideoOptionChange($event, videoOption) {
        if ($event && $event.target && $event.target.checked) {
            this.selectedVideoOptions.push(videoOption)
        } else {
            this.selectedVideoOptions = this.selectedVideoOptions.filter(option => option.creative_product_id !== videoOption.creative_product_id);
        }
    }

    onVideoQuantityChange(quantity: IOptionProps, videoOption) {
        this.videoOptions.forEach((option) => {
            if (option.creative_product_id === videoOption.creative_product_id) {
                option.quantity = _.parseInt(quantity.value);
            }
        });
    }

    cancel() {
        if (this.backToCampaignId) {
            this.backingToCampaignPage = true;
            this.router.navigate(['campaign/edit', this.backToCampaignId], { queryParams: { "fromCreative": true } }).catch((e) => {
                this.backingToCampaignPage = false;
            });
        } else {
            this.router.navigate([ObjectType.Creative, 'list']);
        }
    }

    toCreativeNamePage() {
        if (this.selectedVideoOptions.length === 0 || this.selectedLanguage.length === 0) {
            this.modal.error({
                message: 'Please choose both video option and language option',
                subMessage: ''
            });
        } else {
            this.isCreativeRename = true;
            this.isVideoProduce = false;
        }
    }

    backToVideoProduce() {
        this.isCreativeRename = false;
        this.isVideoProduce = true;
        this.selectedLanguage = [];
        this.selectedVideoOptions = [];
    }

    changeSampleVideoUrl(url: IOptionProps) {
        this.videoControls.nativeElement.pause();
        this.previewUrl = url.value;
        this.videoControls.nativeElement.load();
        this.videoControls.nativeElement.play();
    }
}
